import { currencyInput } from '@/_schemas/generic';
import type { RouteListItem } from '@/types';

import { type InventoryVendorFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<InventoryVendorFormSchema> = {
  id: -1,
  name: '',
  vendor_id: '',
  account_number: '',
  sku_label: '',
  sku_start_number: '',
  tax_id: '',
  url: '',
  credit_limit: currencyInput.defaultValue(),
  notes: '',
  phone_numbers: [],
  vendor_w9_file: [],
  minimum_order_required: false,
  pivot: {
    type: 'secondary',
  },
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/inventory-vendors', name: 'Vendors' },
];
